import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const DepartmentServices = {

    getAll: async (isPaginated = false, pageSize = 10, pageNumber = 1) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Department/GetAll`, {
                params: { isPaginated, pageSize, pageNumber },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể tải danh sách phòng ban!";
            throw new Error(errorMessage);
        }
    },
};

export default DepartmentServices;